// extracted by mini-css-extract-plugin
module.exports = {"menuListContainer":"az_odb","link":"az_pdb"};